import React, { useState, useEffect, useRef } from 'react';
import {
  Container, Paper, Box, Typography, Grid, Card, CardContent, Button, TextField,
  Chip, Tab, Tabs, Tooltip, IconButton,
  Modal, Divider, Dialog, DialogTitle,
  DialogContent, DialogActions, Table, TableBody, TableCell, TableRow,
  List, ListItem, ListItemText, ListItemIcon, Stack, Snackbar, Alert,
  CircularProgress
} from '@mui/material';
import {
  Description, Add, Edit, Delete, PictureAsPdf, Send, FileCopy,
  CheckCircle, PendingActions, Cancel, Visibility,
  Close, WhatsApp, Email, ContentCopy, History,
  Error as ErrorIcon, CloudUpload
} from '@mui/icons-material';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import * as contratosService from '../../../services/contratosService';

// MOCK DATA - Variáveis disponíveis
const VARIAVEIS_DISPONIVEIS = {
  'Delta Rent Car': [
    { key: '{{easy_logo}}', label: 'Logo da Empresa', exemplo: '<img src="..." />' },
    { key: '{{easy_razao_social}}', label: 'Razão Social', exemplo: 'Delta Rent Car LTDA' },
    { key: '{{easy_cnpj}}', label: 'CNPJ', exemplo: '12.345.678/0001-99' },
    { key: '{{easy_endereco}}', label: 'Endereço', exemplo: 'Av. Principal, 123' },
    { key: '{{easy_cidade}}', label: 'Cidade', exemplo: 'Manaus' },
    { key: '{{easy_estado}}', label: 'Estado', exemplo: 'AM' },
    { key: '{{easy_telefone}}', label: 'Telefone', exemplo: '(92) 3234-5678' },
    { key: '{{easy_email}}', label: 'E-mail', exemplo: 'contato@deltarentcar.com.br' },
  ],
  'Cliente': [
    { key: '{{cliente_nome}}', label: 'Nome Completo', exemplo: 'João Silva' },
    { key: '{{cliente_cpf}}', label: 'CPF/CNPJ', exemplo: '123.456.789-00' },
    { key: '{{cliente_endereco}}', label: 'Endereço', exemplo: 'Rua das Flores, 456' },
    { key: '{{cliente_estado}}', label: 'Estado (UF)', exemplo: 'AM' },
    { key: '{{cliente_telefone}}', label: 'Telefone', exemplo: '(92) 99999-9999' },
    { key: '{{cliente_email}}', label: 'E-mail', exemplo: 'joao@email.com' },
  ],
  'Veículo': [
    { key: '{{veiculo_marca}}', label: 'Marca', exemplo: 'Volkswagen' },
    { key: '{{veiculo_modelo}}', label: 'Modelo', exemplo: 'Gol 1.0' },
    { key: '{{veiculo_placa}}', label: 'Placa', exemplo: 'ABC-1234' },
    { key: '{{veiculo_chassi}}', label: 'Chassi', exemplo: '9BWZZZ377VT004251' },
    { key: '{{veiculo_renavam}}', label: 'Renavam', exemplo: '12345678901' },
  ],
  'Datas': [
    { key: '{{data_inicio}}', label: 'Data Início', exemplo: '01/01/2025' },
    { key: '{{data_fim}}', label: 'Data Fim', exemplo: '10/01/2025' },
    { key: '{{data_contrato}}', label: 'Data do Contrato', exemplo: '31/12/2024' },
    { key: '{{dias_locacao}}', label: 'Dias de Locação', exemplo: '10' },
    { key: '{{hora_retirada}}', label: 'Hora Retirada', exemplo: '09:00' },
    { key: '{{hora_devolucao}}', label: 'Hora Devolução', exemplo: '18:00' },
  ],
  'Aluguel/Reserva': [
    { key: '{{tipo_periodo}}', label: 'Tipo Período', exemplo: 'Diária' },
    { key: '{{quantidade_periodos}}', label: 'Quantidade Períodos', exemplo: '10' },
    { key: '{{data_retirada}}', label: 'Data Retirada', exemplo: '01/01/2025' },
    { key: '{{data_devolucao}}', label: 'Data Devolução', exemplo: '10/01/2025' },
    { key: '{{dias_total}}', label: 'Dias Total', exemplo: '10' },
    { key: '{{status_aluguel}}', label: 'Status Aluguel', exemplo: 'Em Andamento' },
    { key: '{{status_pagamento}}', label: 'Status Pagamento', exemplo: 'Pago' },
  ],
  'Valores': [
    { key: '{{valor_diaria}}', label: 'Valor Diária', exemplo: 'R$ 150,00' },
    { key: '{{valor_bruto}}', label: 'Valor Bruto', exemplo: 'R$ 1.500,00' },
    { key: '{{desconto_valor}}', label: 'Desconto', exemplo: 'R$ 100,00' },
    { key: '{{valor_total}}', label: 'Valor Total', exemplo: 'R$ 1.400,00' },
    { key: '{{valor_caucao}}', label: 'Caução', exemplo: 'R$ 500,00' },
    { key: '{{multas_valor}}', label: 'Valor Multas', exemplo: 'R$ 100,00' },
    { key: '{{dias_atraso}}', label: 'Dias Atraso', exemplo: '2' },
    { key: '{{valor_multa_atraso}}', label: 'Multa Atraso', exemplo: 'R$ 50,00' },
  ],
  'Pagamento': [
    { key: '{{forma_pagamento}}', label: 'Forma Pagamento', exemplo: 'Cartão de Crédito' },
    { key: '{{bandeira_cartao}}', label: 'Bandeira Cartão', exemplo: 'Visa' },
    { key: '{{pago_na_retirada}}', label: 'Pago na Retirada', exemplo: 'Sim' },
    { key: '{{observacoes_pagamento}}', label: 'Obs. Pagamento', exemplo: 'Pago em 2x' },
  ],
  'Assinatura': [
    { key: '{{assinatura_cliente}}', label: 'Espaço Assinatura Cliente', exemplo: '[ESPAÇO PARA ASSINATURA]' },
    { key: '{{data_assinatura}}', label: 'Data da Assinatura', exemplo: '31/12/2024' },
    { key: '{{ip_assinatura}}', label: 'IP da Assinatura', exemplo: '192.168.1.100' },
  ],
};

const FRONTEND_URL = 'https://locadora.athixdev.xyz';

export default function Contratos() {
  const [tabIndex, setTabIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  
  // Estados Templates
  const [templates, setTemplates] = useState([]);
  const [templateSelecionado, setTemplateSelecionado] = useState(null);
  const [modalTemplateAberto, setModalTemplateAberto] = useState(false);
  const [modalVisualizarAberto, setModalVisualizarAberto] = useState(false);
  const [templateVisualizacao, setTemplateVisualizacao] = useState(null);
  const [modoEdicaoTemplate, setModoEdicaoTemplate] = useState(false);
  const [editorContent, setEditorContent] = useState('');
  const [nomeTemplate, setNomeTemplate] = useState('');
  const [descricaoTemplate, setDescricaoTemplate] = useState('');
  const quillRef = useRef(null);
  
  // Estados Contratos
  const [contratos, setContratos] = useState([]);
  const [contratoSelecionado, setContratoSelecionado] = useState(null);
  const [modalContratoAberto, setModalContratoAberto] = useState(false);
  const [modalEnviarAberto, setModalEnviarAberto] = useState(false);
  const [modalHistoricoAberto, setModalHistoricoAberto] = useState(false);
  const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
  const [modalDadosEmpresaAberto, setModalDadosEmpresaAberto] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [dadosEmpresa, setDadosEmpresa] = useState({
    empresa_razao_social: '',
    empresa_cnpj: '',
    empresa_endereco: '',
    empresa_cidade: '',
    empresa_estado: '',
    empresa_telefone: '',
    empresa_email: '',
    empresa_logo: ''
  });
  const [uploadingLogo, setUploadingLogo] = useState(false);

  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // success, error, warning, info
  });

  // Estatísticas
  const [estatisticas, setEstatisticas] = useState({
    total: 0,
    aguardando: 0,
    assinados: 0,
    expirados: 0,
    cancelados: 0,
    valorTotal: 0,
  });

  useEffect(() => {
    carregarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex]);

  useEffect(() => {
    calcularEstatisticas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contratos]);

  async function carregarDados() {
    setLoading(true);
    try {
      if (tabIndex === 0) {
        // Carregar templates
        const templatesData = await contratosService.listarTemplates();
        setTemplates(templatesData);
        const config = await contratosService.buscarConfiguracoesContratos();
        setDadosEmpresa({
          empresa_razao_social: config.empresa_razao_social || '',
          empresa_cnpj: config.empresa_cnpj || '',
          empresa_endereco: config.empresa_endereco || '',
          empresa_cidade: config.empresa_cidade || '',
          empresa_estado: config.empresa_estado || '',
          empresa_telefone: config.empresa_telefone || '',
          empresa_email: config.empresa_email || '',
          empresa_logo: config.empresa_logo || ''
        });
      } else {
        // Carregar contratos gerados
        const contratosData = await contratosService.listarContratos();
        setContratos(contratosData);
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setSnackbar({
        open: true,
        message: 'Erro ao carregar dados. Verifique a conexão com o servidor.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }

  function calcularEstatisticas() {
    const total = contratos.length;
    const aguardando = contratos.filter(c => c.status === 'Aguardando Assinatura').length;
    const assinados = contratos.filter(c => c.status === 'Assinado').length;
    const expirados = contratos.filter(c => c.status === 'Expirado').length;
    const cancelados = contratos.filter(c => c.status === 'Cancelado').length;
    const valorTotal = contratos.reduce((sum, c) => sum + c.valor_total, 0);

    setEstatisticas({ total, aguardando, assinados, expirados, cancelados, valorTotal });
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'Assinado': return 'success';
      case 'Aguardando Assinatura': return 'warning';
      case 'Expirado': return 'error';
      case 'Cancelado': return 'default';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Assinado': return <CheckCircle />;
      case 'Aguardando Assinatura': return <PendingActions />;
      case 'Expirado': return <ErrorIcon />;
      case 'Cancelado': return <Cancel />;
      default: return <Description />;
    }
  };

  const formatarData = (data) => {
    if (!data) return '-';
    return new Date(data).toLocaleString('pt-BR', { timeZone: 'America/Manaus' });
  };

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  };

  // Funções Contratos
  const reenviarContrato = async (contratoId, opcoes) => {
    try {
      setLoading(true);
      await contratosService.reenviarContrato(contratoId, opcoes);
      setSnackbar({
        open: true,
        message: 'Contrato reenviado com sucesso!',
        severity: 'success'
      });
    } catch (error) {
      console.error('Erro ao reenviar contrato:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.erro || 'Erro ao reenviar contrato',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const copiarLinkContrato = (token) => {
    const url = `${FRONTEND_URL}/contratos/assinar/${token}`;
    navigator.clipboard.writeText(url);
    setSnackbar({
      open: true,
      message: 'Link copiado para área de transferência!',
      severity: 'success'
    });
  };

  // Funções Templates
  const visualizarTemplate = async (template) => {
    try {
      setLoading(true);
      const templateCompleto = await contratosService.buscarTemplate(template.id);
      setTemplateVisualizacao(templateCompleto);
      setModalVisualizarAberto(true);
    } catch (error) {
      console.error('Erro ao carregar template:', error);
      setSnackbar({
        open: true,
        message: 'Erro ao carregar template',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const abrirModalTemplate = async (template = null) => {
    if (template) {
      setTemplateSelecionado(template);
      setNomeTemplate(template.nome || '');
      setDescricaoTemplate(template.descricao || '');
      
      // Se o template não tem conteúdo_html carregado, buscar do servidor
      if (!template.conteudo_html && template.id) {
        try {
          setLoading(true);
          const templateCompleto = await contratosService.buscarTemplate(template.id);
          setEditorContent(templateCompleto.conteudo_html || '');
          setTemplateSelecionado(templateCompleto);
        } catch (error) {
          console.error('Erro ao carregar template:', error);
          setSnackbar({
            open: true,
            message: 'Erro ao carregar conteúdo do template',
            severity: 'error'
          });
          setEditorContent('');
        } finally {
          setLoading(false);
        }
      } else {
        setEditorContent(template.conteudo_html || '');
      }
      
      setModoEdicaoTemplate(true);
    } else {
      setTemplateSelecionado(null);
      setNomeTemplate('');
      setDescricaoTemplate('');
      setEditorContent('');
      setModoEdicaoTemplate(false);
    }
    setModalTemplateAberto(true);
  };

  const salvarTemplate = async () => {
    if (!nomeTemplate.trim()) {
      setSnackbar({
        open: true,
        message: 'Nome do template é obrigatório',
        severity: 'warning'
      });
      return;
    }

    setLoading(true);
    try {
      const dados = {
        nome: nomeTemplate,
        descricao: descricaoTemplate,
        conteudo_html: editorContent,
        ativo: 1
      };

      if (modoEdicaoTemplate) {
        await contratosService.atualizarTemplate(templateSelecionado.id, dados);
        setSnackbar({
          open: true,
          message: 'Template atualizado com sucesso!',
          severity: 'success'
        });
      } else {
        await contratosService.criarTemplate(dados);
        setSnackbar({
          open: true,
          message: 'Template criado com sucesso!',
          severity: 'success'
        });
      }

      setModalTemplateAberto(false);
      carregarDados();
    } catch (error) {
      console.error('Erro ao salvar template:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.mensagem || 'Erro ao salvar template',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const inserirVariavel = (variavel) => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();
      const position = range ? range.index : editor.getLength();
      editor.insertText(position, variavel.key);
      
      setSnackbar({
        open: true,
        message: `Variável ${variavel.label} inserida!`,
        severity: 'success'
      });
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
    if (!allowed.includes(file.type)) {
      setSnackbar({ open: true, message: 'Apenas imagens JPG, PNG, WebP ou GIF são aceitas', severity: 'warning' });
      return;
    }
    try {
      setUploadingLogo(true);
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await (await import('axios')).default.post(
        `${process.env.REACT_APP_API_URL}/upload/image`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
      );
      setDadosEmpresa(prev => ({ ...prev, empresa_logo: data.url }));
      setSnackbar({ open: true, message: 'Logo enviada com sucesso!', severity: 'success' });
    } catch (err) {
      console.error('Erro ao enviar logo:', err);
      setSnackbar({ open: true, message: 'Erro ao enviar logo', severity: 'error' });
    } finally {
      setUploadingLogo(false);
    }
  };

  const salvarDadosEmpresa = async () => {
    try {
      setLoading(true);
      await contratosService.atualizarConfiguracoesContratos(dadosEmpresa);
      setSnackbar({
        open: true,
        message: 'Dados da empresa salvos com sucesso!',
        severity: 'success'
      });
      setModalDadosEmpresaAberto(false);
    } catch (error) {
      console.error('Erro ao salvar dados da empresa:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.erro || 'Erro ao salvar dados da empresa',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const duplicarTemplate = async (template) => {
    setLoading(true);
    try {
      const novoTemplate = {
        nome: `${template.nome} (Cópia)`,
        descricao: template.descricao,
        conteudo_html: template.conteudo_html,
        ativo: 1
      };
      
      await contratosService.criarTemplate(novoTemplate);
      setSnackbar({
        open: true,
        message: 'Template duplicado com sucesso!',
        severity: 'success'
      });
      carregarDados();
    } catch (error) {
      console.error('Erro ao duplicar template:', error);
      setSnackbar({
        open: true,
        message: 'Erro ao duplicar template',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const deletarTemplate = async (id) => {
    if (window.confirm('Deseja realmente excluir este template?')) {
      setLoading(true);
      try {
        await contratosService.excluirTemplate(id);
        setSnackbar({
          open: true,
          message: 'Template excluído com sucesso!',
          severity: 'success'
        });
        carregarDados();
      } catch (error) {
        console.error('Erro ao excluir template:', error);
        setSnackbar({
          open: true,
          message: error.response?.data?.mensagem || 'Erro ao excluir template',
          severity: 'error'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const toggleAtivoTemplate = async (id) => {
    setLoading(true);
    try {
      await contratosService.alternarStatusTemplate(id);
      setSnackbar({
        open: true,
        message: 'Status alterado com sucesso!',
        severity: 'success'
      });
      carregarDados();
    } catch (error) {
      console.error('Erro ao alterar status:', error);
      setSnackbar({
        open: true,
        message: 'Erro ao alterar status do template',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // Funções Contratos
  // eslint-disable-next-line no-unused-vars
  const visualizarContrato = (contrato) => {
    setContratoSelecionado(contrato);
    setModalContratoAberto(true);
  };

  const enviarContrato = (contrato) => {
    setContratoSelecionado(contrato);
    setModalEnviarAberto(true);
  };

  const verHistorico = async (contrato) => {
    setContratoSelecionado(contrato);
    setLoading(true);
    try {
      const historicoDados = await contratosService.listarHistorico(contrato.id);
      setHistorico(historicoDados);
      setModalHistoricoAberto(true);
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      setHistorico([]);
      setModalHistoricoAberto(true);
    } finally {
      setLoading(false);
    }
  };

  const confirmarEnvio = async (canal) => {
    if (!contratoSelecionado) return;
    setLoading(true);
    try {
      await contratosService.reenviarContrato(contratoSelecionado.id, {
        whatsapp: canal === 'WhatsApp',
        email: canal === 'E-mail'
      });
      setSnackbar({ open: true, message: `Contrato enviado via ${canal}!`, severity: 'success' });
      setModalEnviarAberto(false);
      carregarDados();
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.erro || `Erro ao enviar via ${canal}`,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const copiarLink = (link) => {
    navigator.clipboard.writeText(link);
    setSnackbar({
      open: true,
      message: 'Link copiado para área de transferência!',
      severity: 'success'
    });
  };

  const confirmarCancelamento = async () => {
    if (!contratoSelecionado) return;
    
    setLoading(true);
    try {
      const observacoes = prompt('Motivo do cancelamento:');
      if (observacoes !== null) {
        await contratosService.cancelarContrato(contratoSelecionado.id, observacoes);
        setSnackbar({
          open: true,
          message: 'Contrato cancelado com sucesso!',
          severity: 'success'
        });
        setModalExcluirAberto(false);
        carregarDados();
      }
    } catch (error) {
      console.error('Erro ao cancelar contrato:', error);
      setSnackbar({
        open: true,
        message: 'Erro ao cancelar contrato',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // eslint-disable-next-line no-unused-vars
  const baixarPDF = async (contrato) => {
    setSnackbar({ open: true, message: 'Gerando PDF do contrato...', severity: 'info' });

    try {
      // Buscar contrato completo (com conteudo_html) se ainda não veio na listagem
      let htmlContrato = contrato?.conteudo_html;
      if (!htmlContrato && contrato?.id) {
        const token = localStorage.getItem('token');
        const API_URL = process.env.REACT_APP_API_URL;
        const { data } = await (await import('axios')).default.get(
          `${API_URL}/contratos/${contrato.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        htmlContrato = data?.conteudo_html;
      }

      if (!htmlContrato) {
        setSnackbar({ open: true, message: 'Contrato sem conteúdo para gerar PDF', severity: 'warning' });
        return;
      }

      const janela = window.open('', '_blank');
      if (!janela) {
        setSnackbar({ open: true, message: 'Permita pop-ups para gerar o PDF', severity: 'error' });
        return;
      }

      const nomeCliente = contrato.cliente?.nome || 'Cliente';
      const numContrato = contrato.numero_contrato || `CONT-${String(contrato.id).padStart(6, '0')}`;

      janela.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8">
  <title>Contrato ${numContrato}</title>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@2/dist/quill.snow.css">
  <style>
    @page { size: A4; margin: 20mm 25mm; }
    * { box-sizing: border-box; }
    body {
      font-family: 'Times New Roman', Times, serif;
      font-size: 12pt;
      line-height: 1.6;
      color: #111;
      background: #fff;
      margin: 0;
      padding: 0;
    }
    .no-print {
      position: fixed; top: 0; left: 0; right: 0;
      background: #3e4095; color: #fff;
      padding: 10px 20px;
      display: flex; align-items: center; justify-content: space-between;
      z-index: 9999;
      font-family: Arial, sans-serif;
    }
    .no-print button {
      background: #ed3237; color: #fff; border: none;
      padding: 8px 20px; border-radius: 4px; cursor: pointer;
      font-size: 14px; font-weight: bold;
    }
    .contrato-body { padding: 0; }
    h1,h2,h3 { page-break-after: avoid; }
    p { text-align: justify; margin: 8px 0; }
    table { width: 100%; border-collapse: collapse; margin: 12px 0; }
    td, th { border: 1px solid #ccc; padding: 6px 10px; font-size: 11pt; }
    @media print {
      .no-print { display: none !important; }
      body { margin: 0; padding: 0; }
    }
  </style>
</head>
<body>
  <div class="no-print">
    <span>Contrato ${numContrato} — ${nomeCliente}</span>
    <button onclick="window.print()">🖨️ Imprimir / Salvar PDF</button>
  </div>
  <div class="contrato-body ql-editor">
    ${htmlContrato}
  </div>
</body>
</html>`);
      janela.document.close();
      setSnackbar({ open: true, message: 'PDF aberto — clique em "Imprimir / Salvar PDF"', severity: 'success' });
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      setSnackbar({ open: true, message: 'Erro ao gerar PDF', severity: 'error' });
    }
  };

  // eslint-disable-next-line no-unused-vars
  const cancelarContrato = (contrato) => {
    setContratoSelecionado(contrato);
    setModalExcluirAberto(true);
  };

  // Colunas da tabela de templates
  const colunasTemplates = [
    { accessorKey: 'nome', header: 'Nome', size: 200 },
    { accessorKey: 'descricao', header: 'Descrição', size: 250 },
    {
      accessorKey: 'usado_em',
      header: 'Usado em',
      size: 100,
      // eslint-disable-next-line react/prop-types
      Cell: ({ cell }) => `${cell.getValue()} contratos`,
    },
    {
      accessorKey: 'ativo',
      header: 'Status',
      size: 100,
      // eslint-disable-next-line react/prop-types
      Cell: ({ cell }) => {
        // eslint-disable-next-line react/prop-types
        const v = cell.getValue();
        return <Chip label={v ? 'Ativo' : 'Inativo'} color={v ? 'success' : 'default'} size="small" />;
      },
    },
    {
      accessorKey: 'criado_em',
      header: 'Criado em',
      size: 150,
      // eslint-disable-next-line react/prop-types
      Cell: ({ cell }) => formatarData(cell.getValue()),
    },
  ];

  // Colunas da tabela de contratos
  const colunasContratos = [
    { accessorKey: 'numero_contrato', header: 'Nº Contrato', size: 130 },
    {
      accessorKey: 'nome_cliente',
      header: 'Cliente',
      size: 180,
      Cell: ({ row }) => row.original.cliente?.nome || row.original.nome_cliente || '-',
    },
    {
      id: 'veiculo',
      header: 'Veículo',
      size: 140,
      accessorFn: (row) => row.veiculo?.modelo || row.modelo_veiculo || '',
      Cell: ({ row }) => {
        const modelo = row.original.veiculo?.modelo || row.original.modelo_veiculo || '';
        const placa = row.original.veiculo?.placa || row.original.placa_veiculo || '';
        return modelo ? `${modelo}${placa ? ` (${placa})` : ''}` : '-';
      },
    },
    {
      accessorKey: 'status',
      header: 'Status',
      size: 160,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        return <Chip icon={getStatusIcon(v)} label={v} color={getStatusColor(v)} size="small" />;
      },
    },
    {
      accessorKey: 'valor_total',
      header: 'Valor Total',
      size: 120,
      Cell: ({ cell }) => formatarValor(cell.getValue()),
    },
    {
      accessorKey: 'data_geracao',
      header: 'Gerado em',
      size: 150,
      Cell: ({ cell }) => formatarData(cell.getValue()),
    },
    {
      accessorKey: 'data_assinatura',
      header: 'Assinado em',
      size: 150,
      Cell: ({ cell }) => formatarData(cell.getValue()),
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Description fontSize="large" color="primary" />
            Gestão de Contratos
          </Typography>
        </Box>

        <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)} sx={{ mb: 3 }}>
          <Tab label="📝 Templates" />
          <Tab label="📄 Contratos" />
          <Tab label="📊 Estatísticas" />
        </Tabs>

        {/* ABA 1: TEMPLATES */}
        {tabIndex === 0 && (
          <Box>
            <Box display="flex" justifyContent="space-between" mb={3}>
              <Typography variant="h6">Templates de Contrato</Typography>
              <Button
                variant="outlined"
                onClick={() => setModalDadosEmpresaAberto(true)}
              >
                Dados da Empresa
              </Button>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => abrirModalTemplate()}
              >
                Novo Template
              </Button>
            </Box>

            <MaterialReactTable
              columns={colunasTemplates}
              data={templates}
              localization={MRT_Localization_PT_BR}
              enableRowActions
              positionActionsColumn="last"
              renderRowActions={({ row }) => (
                <Box display="flex" gap={1}>
                  <Tooltip title="Visualizar">
                    <IconButton size="small" onClick={() => visualizarTemplate(row.original)} color="info">
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Editar">
                    <IconButton size="small" onClick={() => abrirModalTemplate(row.original)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Duplicar">
                    <IconButton size="small" onClick={() => duplicarTemplate(row.original)}>
                      <FileCopy fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={row.original.ativo ? 'Desativar' : 'Ativar'}>
                    <IconButton size="small" onClick={() => toggleAtivoTemplate(row.original.id)}>
                      {row.original.ativo ? <CheckCircle fontSize="small" color="success" /> : <Cancel fontSize="small" />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Deletar">
                    <IconButton size="small" onClick={() => deletarTemplate(row.original.id)} color="error">
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              muiTablePaperProps={{ elevation: 0, sx: { borderRadius: 2 } }}
            />
          </Box>
        )}

        {/* ABA 2: CONTRATOS */}
        {tabIndex === 1 && (
          <Box>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, borderTop: '4px solid #2196f3' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="caption" color="text.secondary">Total</Typography>
                        <Typography variant="h4" fontWeight="bold" color="primary">{estatisticas.total}</Typography>
                      </Box>
                      <Description sx={{ fontSize: 48, color: '#2196f3', opacity: 0.3 }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, borderTop: '4px solid #ff9800' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="caption" color="text.secondary">Aguardando</Typography>
                        <Typography variant="h4" fontWeight="bold" color="warning.main">{estatisticas.aguardando}</Typography>
                      </Box>
                      <PendingActions sx={{ fontSize: 48, color: '#ff9800', opacity: 0.3 }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, borderTop: '4px solid #4caf50' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="caption" color="text.secondary">Assinados</Typography>
                        <Typography variant="h4" fontWeight="bold" color="success.main">{estatisticas.assinados}</Typography>
                      </Box>
                      <CheckCircle sx={{ fontSize: 48, color: '#4caf50', opacity: 0.3 }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, borderTop: '4px solid #f44336' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="caption" color="text.secondary">Expirados</Typography>
                        <Typography variant="h4" fontWeight="bold" color="error.main">{estatisticas.expirados}</Typography>
                      </Box>
                      <ErrorIcon sx={{ fontSize: 48, color: '#f44336', opacity: 0.3 }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, borderTop: '4px solid #9c27b0' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="caption" color="text.secondary">Cancelados</Typography>
                        <Typography variant="h4" fontWeight="bold" sx={{ color: '#9c27b0' }}>{estatisticas.cancelados}</Typography>
                      </Box>
                      <Cancel sx={{ fontSize: 48, color: '#9c27b0', opacity: 0.3 }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <MaterialReactTable
              columns={colunasContratos}
              data={contratos}
              localization={MRT_Localization_PT_BR}
              enableRowActions
              positionActionsColumn="last"
              renderRowActions={({ row }) => (
                <Box display="flex" gap={1}>
                  <Tooltip title="Copiar link de assinatura">
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => copiarLinkContrato(row.original.token_assinatura)}
                        color="primary"
                        disabled={!row.original.token_assinatura}
                      >
                        <ContentCopy fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  {row.original.status === 'Aguardando Assinatura' && row.original.telefone_cliente && (
                    <Tooltip title="Reenviar via WhatsApp">
                      <IconButton
                        size="small"
                        onClick={() => reenviarContrato(row.original.id, { whatsapp: true, email: false })}
                        color="success"
                      >
                        <WhatsApp fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                  {row.original.status === 'Aguardando Assinatura' && row.original.email_cliente && (
                    <Tooltip title="Reenviar via E-mail">
                      <IconButton
                        size="small"
                        onClick={() => reenviarContrato(row.original.id, { whatsapp: false, email: true })}
                        color="info"
                      >
                        <Email fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title="Abrir contrato">
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => window.open(`${FRONTEND_URL}/contratos/assinar/${row.original.token_assinatura}`, '_blank')}
                        disabled={!row.original.token_assinatura}
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip title="Excluir contrato">
                    <IconButton
                      size="small"
                      color="error"
                      onClick={async () => {
                        if (window.confirm(`Excluir contrato ${row.original.numero_contrato}? Esta ação não pode ser desfeita.`)) {
                          try {
                            await contratosService.excluirContrato(row.original.id);
                            setSnackbar({ open: true, message: 'Contrato excluído!', severity: 'success' });
                            carregarDados();
                          } catch (err) {
                            setSnackbar({ open: true, message: 'Erro ao excluir contrato', severity: 'error' });
                          }
                        }
                      }}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              muiTablePaperProps={{ elevation: 0, sx: { borderRadius: 2 } }}
            />
          </Box>
        )}

        {/* ABA 3: ESTATÍSTICAS */}
        {tabIndex === 2 && (
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 3, p: 3 }}>
                  <Typography variant="h6" gutterBottom>📈 Resumo Geral</Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon><Description color="primary" /></ListItemIcon>
                      <ListItemText primary="Total de Contratos" secondary={estatisticas.total} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon><PendingActions color="warning" /></ListItemIcon>
                      <ListItemText primary="Aguardando Assinatura" secondary={estatisticas.aguardando} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                      <ListItemText primary="Contratos Assinados" secondary={estatisticas.assinados} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon><ErrorIcon color="error" /></ListItemIcon>
                      <ListItemText primary="Contratos Expirados" secondary={estatisticas.expirados} />
                    </ListItem>
                  </List>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 3, p: 3 }}>
                  <Typography variant="h6" gutterBottom>💰 Valores</Typography>
                  <Typography variant="h4" color="primary" fontWeight="bold" mt={2}>
                    {formatarValor(estatisticas.valorTotal)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mt={1}>
                    Valor total em contratos
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body1">
                    Taxa de assinatura: <strong>85%</strong>
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    Tempo médio para assinar: <strong>2h 30min</strong>
                  </Typography>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>

      {/* MODAL: CRIAR/EDITAR TEMPLATE */}
      <Modal open={modalTemplateAberto} onClose={() => setModalTemplateAberto(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '90%', md: '80%', lg: 1200 },
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24
        }}>
          <Box sx={{ p: 3, borderBottom: '1px solid #eee', position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 10 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Description /> {modoEdicaoTemplate ? 'Editar Template' : 'Novo Template'}
              </Typography>
              <IconButton onClick={() => setModalTemplateAberto(false)}>
                <Close />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ p: 3 }}>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Nome do Template *"
                  fullWidth
                  value={nomeTemplate}
                  onChange={(e) => setNomeTemplate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Descrição"
                  fullWidth
                  value={descricaoTemplate}
                  onChange={(e) => setDescricaoTemplate(e.target.value)}
                />
              </Grid>
            </Grid>

            <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
              <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                🔖 Variáveis Disponíveis (Clique para inserir):
              </Typography>
              <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
                {Object.entries(VARIAVEIS_DISPONIVEIS).map(([categoria, variaveis]) => (
                  <Box key={categoria} mb={2}>
                    <Typography variant="caption" fontWeight="bold" color="primary">
                      {categoria}:
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
                      {variaveis.map((v) => (
                        <Chip
                          key={v.key}
                          label={v.label}
                          size="small"
                          onClick={() => inserirVariavel(v)}
                          sx={{ cursor: 'pointer' }}
                          title={`Inserir ${v.key} - Exemplo: ${v.exemplo}`}
                        />
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Paper>

            <Box sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden', minHeight: 400 }}>
              <ReactQuill
                ref={quillRef}
                theme="snow"
                value={editorContent}
                onChange={setEditorContent}
                style={{ height: '400px' }}
                modules={{
                  toolbar: [
                    [{ 'header': [1, 2, 3, false] }],
                    [{ 'font': [] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['link', 'image'],
                    ['clean']
                  ]
                }}
              />
            </Box>
          </Box>

          <Box sx={{ p: 3, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button variant="outlined" onClick={() => setModalTemplateAberto(false)}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={salvarTemplate}>
              {modoEdicaoTemplate ? 'Atualizar' : 'Salvar Template'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* MODAL: VISUALIZAR TEMPLATE */}
      <Modal open={modalVisualizarAberto} onClose={() => setModalVisualizarAberto(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 900,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 3,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">
              📄 {templateVisualizacao?.nome || 'Visualizar Template'}
            </Typography>
            <IconButton onClick={() => setModalVisualizarAberto(false)}>
              <Close />
            </IconButton>
          </Box>
          
          <Box sx={{ p: 3, overflow: 'auto', flex: 1 }}>
            {templateVisualizacao?.descricao && (
              <Box mb={2}>
                <Typography variant="subtitle2" color="text.secondary">Descrição:</Typography>
                <Typography variant="body2" mb={2}>{templateVisualizacao.descricao}</Typography>
              </Box>
            )}
            
            <Divider sx={{ mb: 2 }} />
            
            <Box 
              sx={{ 
                border: '1px solid #e0e0e0', 
                borderRadius: 2, 
                p: 3,
                bgcolor: '#fff',
                minHeight: 400
              }}
              dangerouslySetInnerHTML={{ __html: templateVisualizacao?.conteudo_html || '<p>Nenhum conteúdo disponível</p>' }}
            />
          </Box>

          <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button variant="outlined" onClick={() => {
              setModalVisualizarAberto(false);
              abrirModalTemplate(templateVisualizacao);
            }}>
              Editar
            </Button>
            <Button variant="contained" onClick={() => setModalVisualizarAberto(false)}>
              Fechar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* MODAL: DADOS DA EMPRESA */}
      <Dialog open={modalDadosEmpresaAberto} onClose={() => setModalDadosEmpresaAberto(false)} maxWidth="md" fullWidth>
        <DialogTitle>Dados da Empresa para Variáveis de Contrato</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            {/* Logo da Empresa */}
            <Grid item xs={12}>
              <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 2 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Logo da Empresa
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                  {dadosEmpresa.empresa_logo ? (
                    <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 1, bgcolor: '#fafafa' }}>
                      <img
                        src={dadosEmpresa.empresa_logo}
                        alt="Logo da empresa"
                        style={{ maxHeight: 80, maxWidth: 200, display: 'block', objectFit: 'contain' }}
                      />
                    </Box>
                  ) : (
                    <Box sx={{
                      width: 140, height: 80, border: '2px dashed #ccc', borderRadius: 1,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      bgcolor: '#f5f5f5', color: '#aaa'
                    }}>
                      <Typography variant="caption" textAlign="center">Sem logo</Typography>
                    </Box>
                  )}
                  <Box>
                    <input
                      accept="image/jpeg,image/png,image/webp,image/gif"
                      style={{ display: 'none' }}
                      id="logo-upload-input"
                      type="file"
                      onChange={handleLogoUpload}
                    />
                    <label htmlFor="logo-upload-input">
                      <Button
                        component="span"
                        variant="outlined"
                        startIcon={uploadingLogo ? <CircularProgress size={16} /> : <CloudUpload />}
                        disabled={uploadingLogo}
                        size="small"
                      >
                        {uploadingLogo ? 'Enviando...' : 'Enviar Logo'}
                      </Button>
                    </label>
                    {dadosEmpresa.empresa_logo && (
                      <Button
                        size="small"
                        color="error"
                        sx={{ ml: 1 }}
                        onClick={() => setDadosEmpresa(prev => ({ ...prev, empresa_logo: '' }))}
                      >
                        Remover
                      </Button>
                    )}
                    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                      JPG, PNG, WebP ou GIF. Use a variável <strong>{'{{easy_logo}}'}</strong> no template.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Razão Social"
                fullWidth
                value={dadosEmpresa.empresa_razao_social}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_razao_social: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="CNPJ"
                fullWidth
                value={dadosEmpresa.empresa_cnpj}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_cnpj: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Endereço"
                fullWidth
                value={dadosEmpresa.empresa_endereco}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_endereco: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Cidade"
                fullWidth
                value={dadosEmpresa.empresa_cidade}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_cidade: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="UF"
                fullWidth
                value={dadosEmpresa.empresa_estado}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_estado: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Telefone"
                fullWidth
                value={dadosEmpresa.empresa_telefone}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_telefone: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="E-mail"
                fullWidth
                value={dadosEmpresa.empresa_email}
                onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, empresa_email: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalDadosEmpresaAberto(false)}>Cancelar</Button>
          <Button variant="contained" onClick={salvarDadosEmpresa}>Salvar</Button>
        </DialogActions>
      </Dialog>

      {/* MODAL: VISUALIZAR CONTRATO */}
      <Modal open={modalContratoAberto} onClose={() => setModalContratoAberto(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '90%', md: 700 },
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24
        }}>
          {contratoSelecionado && (
            <>
              <Box sx={{ p: 3, borderBottom: '1px solid #eee' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">
                    Contrato {contratoSelecionado.numero_contrato}
                  </Typography>
                  <IconButton onClick={() => setModalContratoAberto(false)}>
                    <Close />
                  </IconButton>
                </Box>
                <Chip
                  icon={getStatusIcon(contratoSelecionado.status)}
                  label={contratoSelecionado.status}
                  color={getStatusColor(contratoSelecionado.status)}
                  size="small"
                  sx={{ mt: 1 }}
                />
              </Box>

              <Box sx={{ p: 3 }}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>Nº Contrato:</strong></TableCell>
                      <TableCell>{contratoSelecionado.numero_contrato}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Cliente:</strong></TableCell>
                      <TableCell>{contratoSelecionado.cliente.nome}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>CPF:</strong></TableCell>
                      <TableCell>{contratoSelecionado.cliente.cpf}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Veículo:</strong></TableCell>
                      <TableCell>{contratoSelecionado.veiculo.marca} {contratoSelecionado.veiculo.modelo} ({contratoSelecionado.veiculo.placa})</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Valor Total:</strong></TableCell>
                      <TableCell><strong>{formatarValor(contratoSelecionado.valor_total)}</strong></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Gerado em:</strong></TableCell>
                      <TableCell>{formatarData(contratoSelecionado.data_geracao)}</TableCell>
                    </TableRow>
                    {contratoSelecionado.data_envio && (
                      <TableRow>
                        <TableCell><strong>Enviado em:</strong></TableCell>
                        <TableCell>{formatarData(contratoSelecionado.data_envio)}</TableCell>
                      </TableRow>
                    )}
                    {contratoSelecionado.data_assinatura && (
                      <TableRow>
                        <TableCell><strong>Assinado em:</strong></TableCell>
                        <TableCell>{formatarData(contratoSelecionado.data_assinatura)}</TableCell>
                      </TableRow>
                    )}
                    {contratoSelecionado.data_expiracao && (
                      <TableRow>
                        <TableCell><strong>Expira em:</strong></TableCell>
                        <TableCell>{formatarData(contratoSelecionado.data_expiracao)}</TableCell>
                      </TableRow>
                    )}
                    {contratoSelecionado.link_assinatura && (
                      <TableRow>
                        <TableCell><strong>Link:</strong></TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2" sx={{ wordBreak: 'break-all', fontSize: '0.75rem' }}>
                              {contratoSelecionado.link_assinatura}
                            </Typography>
                            <IconButton size="small" onClick={() => copiarLink(contratoSelecionado.link_assinatura)}>
                              <ContentCopy fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                    {contratoSelecionado.enviado_por.length > 0 && (
                      <TableRow>
                        <TableCell><strong>Enviado por:</strong></TableCell>
                        <TableCell>
                          {contratoSelecionado.enviado_por.map(canal => (
                            <Chip key={canal} label={canal} size="small" sx={{ mr: 0.5 }} />
                          ))}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                <Box mt={3} display="flex" gap={1} flexWrap="wrap">
                  {contratoSelecionado.status === 'Aguardando Assinatura' && (
                    <Button
                      variant="contained"
                      startIcon={<Send />}
                      onClick={() => {
                        setModalContratoAberto(false);
                        enviarContrato(contratoSelecionado);
                      }}
                    >
                      Reenviar
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={<PictureAsPdf />}
                    onClick={() => baixarPDF(contratoSelecionado)}
                  >
                    Baixar PDF
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<History />}
                    onClick={() => {
                      setModalContratoAberto(false);
                      verHistorico(contratoSelecionado);
                    }}
                  >
                    Histórico
                  </Button>
                  {contratoSelecionado.link_assinatura && (
                    <Button
                      variant="outlined"
                      startIcon={<ContentCopy />}
                      onClick={() => copiarLink(contratoSelecionado.link_assinatura)}
                    >
                      Copiar Link
                    </Button>
                  )}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      {/* MODAL: ENVIAR CONTRATO */}
      <Modal open={modalEnviarAberto} onClose={() => setModalEnviarAberto(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: 500 },
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 3
        }}>
          <Typography variant="h6" gutterBottom>
            📤 Enviar Contrato
          </Typography>
          {contratoSelecionado && (
            <Box>
              <Typography variant="body2" color="text.secondary" mb={3}>
                Enviar contrato {contratoSelecionado.numero_contrato} para {contratoSelecionado.cliente.nome}
              </Typography>

              <Stack spacing={2}>
                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<WhatsApp />}
                  color="success"
                  onClick={() => confirmarEnvio('WhatsApp')}
                >
                  Enviar via WhatsApp
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<Email />}
                  color="primary"
                  onClick={() => confirmarEnvio('E-mail')}
                >
                  Enviar via E-mail
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<ContentCopy />}
                  onClick={() => {
                    copiarLink(contratoSelecionado.link_assinatura);
                    setModalEnviarAberto(false);
                  }}
                >
                  Copiar Link
                </Button>
              </Stack>
            </Box>
          )}
        </Box>
      </Modal>

      {/* MODAL: HISTÓRICO */}
      <Modal open={modalHistoricoAberto} onClose={() => setModalHistoricoAberto(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '90%', md: 600 },
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24
        }}>
          {contratoSelecionado && (
            <>
              <Box sx={{ p: 3, borderBottom: '1px solid #eee' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">
                    📊 Histórico - {contratoSelecionado.numero_contrato}
                  </Typography>
                  <IconButton onClick={() => setModalHistoricoAberto(false)}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>

              <Box sx={{ p: 3 }}>
                <List>
                  {historico.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
                      Nenhum histórico encontrado
                    </Typography>
                  ) : (
                    historico.map((acao, index) => (
                      <ListItem key={index} sx={{ borderLeft: '3px solid #2196f3', mb: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                        <ListItemIcon>
                          {acao.meio_envio === 'whatsapp' && <WhatsApp color="success" />}
                          {acao.meio_envio === 'email' && <Email color="primary" />}
                          {acao.meio_envio === 'sms' && <Send color="info" />}
                        </ListItemIcon>
                        <ListItemText
                          primary={`Envio via ${acao.meio_envio?.toUpperCase()}`}
                          secondary={
                            <>
                              <Typography variant="caption" display="block">
                                {formatarData(acao.data_envio)}
                              </Typography>
                              <Typography variant="body2">
                                Para: {acao.destinatario} - Status: {acao.status}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    ))
                  )}
                </List>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      {/* MODAL: CONFIRMAR CANCELAMENTO */}
      <Dialog open={modalExcluirAberto} onClose={() => setModalExcluirAberto(false)}>
        <DialogTitle>⚠️ Cancelar Contrato</DialogTitle>
        <DialogContent>
          {contratoSelecionado && (
            <Typography>
              Deseja realmente cancelar o contrato <strong>{contratoSelecionado.numero_contrato}</strong>?
              Esta ação não pode ser desfeita.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalExcluirAberto(false)}>
            Não, Manter
          </Button>
          <Button onClick={confirmarCancelamento} color="error" variant="contained">
            Sim, Cancelar Contrato
          </Button>
        </DialogActions>
      </Dialog>

      {/* SNACKBAR DE NOTIFICAÇÕES */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
